import { alpha } from "@mui/material/styles";

export const courseCatalogTokens = {
  ink: "var(--color-ink)",
  ink2: "var(--color-ink-2)",
  ink3: "var(--color-ink-3)",
  ink4: "var(--color-ink-4)",
  inkMuted: "var(--color-ink-2)",
  inkSoft: "var(--color-ink-3)",
  line: "var(--color-hairline-cloud)",
  line2: "var(--color-surface-press-light)",
  line3: "var(--color-surface-2)",
  lineStrong: "var(--color-hairline-cloud)",
  surface: "#FFFFFF",
  surface2: "var(--color-surface-2)",
  surface3: "var(--color-surface-press-light)",
  surfaceSoft: "var(--color-surface-2)",
  surfacePressed: "var(--color-surface-press-light)",
  danger: "#B42318",
  danger50: "rgba(180,35,24,.08)",
  danger100: "rgba(180,35,24,.18)",
  grey: "var(--color-ink-3)",
  greyBg: "rgba(107,114,128,.10)",
  shadowSm: "0 1px 0 rgba(20,24,40,.04), 0 1px 3px rgba(20,24,40,.06)",
  shadowMd: "0 8px 24px -10px rgba(20,24,40,.15)",
  shadowLg: "0 18px 50px -22px rgba(20,24,40,.28)",
};

export function getCourseCatalogTokens(theme) {
  const { primary, secondary, background } = theme.palette;

  return {
    primary: primary.main,
    secondary: secondary.main,
    primaryContrastText: theme.palette.getContrastText(primary.main),
    secondaryContrastText: theme.palette.getContrastText(secondary.main),
    canvas: background.default,
    paper: background.paper,
    primarySoft: alpha(primary.main, 0.10),
    primaryBorder: alpha(primary.main, 0.24),
    focusRing: alpha(primary.main, 0.24),
  };
}

export function getCategoryMeta(category, theme) {
  const normalizedCategory = (category || "").toLowerCase();
  let accent = theme.palette.primary.main;

  if (
    normalizedCategory.includes("emt")
    || normalizedCategory.includes("ems")
    || normalizedCategory.includes("medic")
    || normalizedCategory.includes("paramedic")
  ) {
    accent = theme.palette.secondary.main;
  } else if (
    normalizedCategory.includes("safety")
    || normalizedCategory.includes("prevention")
  ) {
    accent = theme.palette.warning.main;
  }

  return {
    accent,
    color: accent,
    bg: alpha(accent, 0.10),
    border: alpha(accent, 0.24),
  };
}

export function getHeroPalette(theme) {
  const background = theme.palette.primary.main;
  const text = theme.palette.getContrastText(background);

  return {
    background,
    text,
    mutedText: alpha(text, 0.72),
    line: alpha(text, 0.12),
    chipBackground: alpha(text, 0.08),
    chipBorder: alpha(text, 0.16),
  };
}
